import { createAction, createApiAction, createErrorAction } from '@saucelabs/sl-util-redux';

import * as commonApi from '../api';

export const createFiltersActions = (types, api) => ({
  clearSelectedFilters: createAction(types.CLEAR_SELECTED_FILTERS),
  selectDateFilter: createAction(types.SELECT_DATE_FILTER),
  selectFilterItems: createAction(types.SELECT_FILTER_ITEMS),
  setFiltersFromURL: createAction(types.SET_FILTERS_FROM_URL),
  removeFilterItem: createAction(types.REMOVE_FILTER_ITEM),
  searchMetadataRequest: createAction(types.SEARCH_METADATA.REQUEST),
  searchMetadataSuccess: createAction(types.SEARCH_METADATA.SUCCESS),
  searchMetadataFailure: createErrorAction(types.SEARCH_METADATA.FAILURE),
  fetchFilters: createApiAction(
    types.FETCH_FILTERS,
    (params) => api.fetchFilters(params),
    { meta: { skipErrorPage: true } },
  ),
  fetchUsers: createApiAction(
    types.FETCH_USERS,
    ({ queryParams = {}, ...params } = {}) => (
      commonApi.fetchUsers(queryParams)
        .then(({ data }) => ({ ...data, ...params }))
    ),
    { meta: { skipErrorPage: true } },
  ),
  fetchTeams: createApiAction(
    types.FETCH_TEAMS,
    () => commonApi.fetchTeams(),
    { meta: { skipErrorPage: true } },
  ),
  initialize: createAction(types.INITIALIZE),
  cleanup: createAction(types.CLEANUP),
});
